import { useState } from 'react';
import styles from '../styles/expandedList.module.scss';

export default function ExpandedList({ data }) {
    const [clicked, setIsClicked] = useState(-1);

    return (
        <div className={styles.expandedList}>
            {data.map((item, key) => (
                <button
                    className={styles.expandedList__item}
                    onClick={() =>
                        clicked !== key ? setIsClicked(key) : setIsClicked(-1)
                    }
                    key={key}
                >
                    <div className={styles.expandedList__item__title + ' ' + (clicked === key ? styles.active : '')}>
                        <b className={styles.title}>{item.title}</b>
                        <img
                            className={
                                clicked !== key ? styles.purple_plus : styles.purple_minus
                            }
                            src={clicked !== key ? "/plus.svg" : "/minusFAQ.svg"}
                            alt=""
                        />
                    </div>
                    {clicked === key && (
                        <p className={styles.expandedList__item__description}>{item.description}</p>
                    )}
                </button>
            ))}
        </div>
    );
}
